import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for the Hero Dropdown module
 */
export default class HeroDropdown extends MessageBus {
  /**
   * Constructor function of the HeroDropdown class
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    this.element = element;
    this.isOpen = false;
    this.mobileBreakpoint = 768;
    this.init();
  }

  init() {
    this.cacheDomReferences().setupHandlers().enable();
    // Initial check for mobile
    this.checkIfMobile();
    return this;
  }

  cacheDomReferences() {
    this.dropdown = this.element.querySelector(
      `.${CLASS_NAMES.NEWS_HERO__DROPDOWN}`
    );
    this.list = this.element.querySelector(CLASS_NAMES.NEWS_HERO__DROPDOWN_UL);
    // Set initial state
    this.list.style.height = '0';
    this.list.style.overflow = 'hidden';
    this.list.style.transition = 'height 0.3s ease-in-out';
    return this;
  }

  enable() {
    this.dropdown.addEventListener(EVENTS.CLICK, this.handleDropdownClick);
    window.addEventListener(EVENTS.RESIZE, this.handleResize);
    return this;
  }

  setupHandlers() {
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
    return this;
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth < this.mobileBreakpoint;
    // Reset styles if not mobile
    if (!this.isMobile) {
      this.list.style.height = '';
      this.list.style.overflow = '';
      this.element.classList.remove(CLASS_NAMES.NEWS_HERO__DROPDOWN_IS_OPEN);
      this.isOpen = false;
    } else if (!this.isOpen) {
      this.list.style.height = '0';
      this.list.style.overflow = 'hidden';
    }
  }

  handleResize() {
    this.checkIfMobile();
  }

  handleDropdownClick(event) {
    // Only handle click if we're on mobile
    if (!this.isMobile) return;

    event.preventDefault();
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.element.classList.add(CLASS_NAMES.NEWS_HERO__DROPDOWN_IS_OPEN);
      const height = this.list.scrollHeight;
      this.list.style.height = `${height}px`;
    } else {
      this.element.classList.remove(CLASS_NAMES.NEWS_HERO__DROPDOWN_IS_OPEN);
      this.list.style.height = '0';
    }
  }
}
